import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { CallUserEntity } from './call-user.entity';
import { UserEntity } from './user.entity';

@Index('call__fk_user__id_fk', ['fkUserId'], {})
@Index('call_externalId_uindex', ['externalId'], { unique: true })
@Entity('call')
export class CallEntity extends BaseEntity {
	@Column('varchar', {
		name: 'externalId',
		nullable: true,
		unique: true,
		length: 64,
	})
	public externalId!: string | null;

	@Column('int', { name: '_fk_user__id', nullable: true, unsigned: true })
	public fkUserId!: number | null;

	@Column('datetime', { name: 'lastImportDate', nullable: true })
	public lastImportDate!: Date | null;

	@Column('varchar', { name: 'result', nullable: true, length: 255 })
	public result!: string | null;

	@Column('text', { name: 'notes', nullable: true })
	public notes!: string | null;

	@Column('text', { name: 'ai_summary', nullable: true })
	public aiSummary!: string | null;

	@ManyToOne(() => UserEntity, (user) => user.calls, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity;

	@OneToMany(() => CallUserEntity, (callUser) => callUser.fkCall, {})
	public callUsers!: Array<CallUserEntity>;
}
